import React, { Component } from 'react';

class Radio extends Component {
    render() {
        const { onChange, onBlur, name, value, checked, disabled } = this.props;
        return (
            <>
                <input
                    type="radio"
                    value={value}
                    name={name}
                    onClick={onBlur}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                />
                {/* <span> {value}</span> */}
                <span onClick={onBlur}> {value}</span>&nbsp; &nbsp; &nbsp; &nbsp;
            </>
        );
    }
}

export default Radio;